import type { StoreConfig } from '../services/types';
import { usePathChangeListener } from './usePathChangeListener';

const extractProductIdentifier = (
  pathname: string,
  regexPattern: string | undefined
): string | undefined => {
  if (!regexPattern) {
    // send back the page user is on so we can store
    // where they engage with the superbar
    return window.location.href;
  }
  const regex = new RegExp(regexPattern);
  const match = pathname.match(regex);

  return match && match[1] ? match[1] : undefined;
};

export const useGetProductId = (storeConfig?: StoreConfig) => {
  const pathname = usePathChangeListener();

  return extractProductIdentifier(
    pathname,
    storeConfig?.answerConfig?.productIdentifierMatch
  );
};
